import { render, staticRenderFns } from "./link-surveys-screens.vue?vue&type=template&id=66fea0a3"
import script from "./link-surveys-screens.vue?vue&type=script&lang=js"
export * from "./link-surveys-screens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports